export const CAROUSEL_CONFIG = {
  slidesToShow: 2,
  responsive: [
    {
      breakpoint: 647,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
}
